<template>
  <div class="container">
    <div class="shade">
      <div class="hamburger" :class="{ active: !isactive }" @click="toggleMenu">
        <div></div>
      </div>
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
      >
        <div v-show="Isactive" class="box-active" ref="menuBox">
          <ul @click="clickbtn('ischoosed1')" ref="navBar">
            <li @click="clickbtn('ischoosed2')">首页</li>
            <li @click="clickbtn('ischoosed3')">调解中心简介</li>
            <li @click="clickbtn('ischoosed4')">调解指南</li>
            <li @click="clickbtn('ischoosed5')">法院导航</li>
            <li @click="clickbtn('ischoosed6')">判决案例</li>
            <li @click="clickbtn('ischoosed7')">调解申请</li>
            <li @click="clickbtn('ischoosed8')">调解员名录</li>
            <li @click="clickbtn('ischoosed9')">案件查询</li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isactive: true, //导航栏展开or关闭
      Isactive: false //导航栏展开or关闭
    };
  },
  mounted() {
    // 获取全部点击事件
    window.addEventListener("mousedown", this.handleonmousedown, true);//加 capture: true 是为了确保更早捕获事件，做更精确判断
    window.addEventListener("touchstart", this.handleonmousedown);
  },
  methods: {
    // 关闭导航
    handleonmousedown(event) {
  const menu = this.$refs.navBar;
  const button = this.$el.querySelector(".hamburger");

  if (
    !menu.contains(event.target) &&  // 点击不在菜单内
    !button.contains(event.target) &&  // 点击也不在按钮上
    this.Isactive
  ) {
    this.Isactive = false;
    this.isactive = true;
  }
},
    // 菜单按钮点击
    toggleMenu() {
      if (this.isactive) {
        this.isactive = false;
        this.Isactive = true;
      } else {
        this.isactive = true;
        this.Isactive = false;
      }
    },
    clickbtn(str) {
      // console.log(str)
      this.isactive = false;
      this.Isactive = false;
      switch (str) {
        case "ischoosed0":
          this.Isactive = true;
          break;
        case "ischoosed1":
          this.isactive = true;
          break;
        case "ischoosed2":
          this.$router.push("/");
          this.isactive = true;
          break;
        case "ischoosed3":
          this.$router.push("/introduction");
          this.isactive = true;
          break;
        case "ischoosed4":
          this.$router.push("/fingerpost");
          this.isactive = true;
          break;
        case "ischoosed5":
          this.$router.push("/navigation");
          this.isactive = true;
          break;
        case "ischoosed6":
          this.$router.push("/JudgmentCase");
          this.isactive = true;
          break;
        case "ischoosed7":
          this.$router.push("/application");
          this.isactive = true;
          break;
        case "ischoosed8":
          this.$router.push("/list");
          this.isactive = true;
          break;
        case "ischoosed9":
          this.$router.push("/CaseInquiry");
          this.isactive = true;
          break;
      }
    },
    // 动画钩子：展开
    beforeEnter(el) {
      el.style.height = "0";
    },
    enter(el) {
      el.style.transition = "height 500ms ease-in-out";
        // 临时设置成 100vh 对应的像素值，让动画能跑
  const fullHeight = window.innerHeight + "px";
  el.style.height = "0";

// 👇 强制 reflow，确保 Safari 不跳过动画
void el.offsetHeight;

el.style.height = fullHeight;
    },
    afterEnter(el) {
      el.style.height = "100vh";
    },
    // 动画钩子：收起
    beforeLeave(el) {
      el.style.height = "100vh";
    },
    leave(el) {
      el.style.transition = "height 500ms ease-in-out";
      void el.offsetHeight; // 强制 reflow
      el.style.height = "0";
    },
    afterLeave(el) {
      el.style.height = "100vh";
    }
  }
};
</script>

<style scoped>
.shade {
  width: 100%;
  height: 100%;
}
li {
  background-color: #ffffff;
}
.container {
  /* float: right; */
  /* margin: 0.625rem 0.625rem 0 0; */
  /* top: calc(50% - 0.875rem); */
  z-index: 9999999999999;
}


/* 菜单本体固定100vh，初始折叠 */
.box-active {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 48px;
  left: 0;
  background: #ffffff;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.box-active ul {
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #29c1aa, #0982f9);
  z-index: 9999999999999;
}

.box-active ul li {
  width: 100%;
  background: linear-gradient(to right, #29c1aa, #0982f9);
  height: 3.5rem;
  display: flex;
  justify-content: flex-start;
  z-index: 9999999999999;
  align-items: center;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 700;
  position: relative; /* 必须加，给 ::after 定位用 */
  padding-left: 16px;
}
/* 在每个 li 右边加箭头 */
.box-active ul li::after {
  content: ">";
  position: absolute;
  right: 32px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.875rem;
  color: #fff;
  opacity: 1;
}

.box-active ul li:last-child {
  border-bottom: none;
  z-index: 9999999999999;
}

.box-active ul li:active {
  color: #2b4ca4;
  z-index: 9999999999999;
}
/* 菜单按钮 */
.hamburger {
  width: 30px;
  height: 20px;
  position: absolute;
  right: 16px;
  top: 13px;
  cursor: pointer;
  z-index: 9999999999;
}
.hamburger::before,
.hamburger::after,
.hamburger div {
  content: "";
  position: absolute;
  height: 3px;
  width: 100%;
  background: #fff;
  transition: all 0.3s ease;
}
.hamburger::before {
  top: 0;
}
.hamburger div {
  top: 50%;
  transform: translateY(-50%);
}
.hamburger::after {
  bottom: 0;
}

/* 点击后的 X 动画 */
.hamburger.active::before {
  transform: rotate(45deg);
  top: 50%;
}
.hamburger.active div {
  opacity: 0;
}
.hamburger.active::after {
  transform: rotate(-45deg);
  bottom: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue